import axios from "axios";
import { getToken, getTokenHeader } from "../../../../screen/auth/action";
import {
  canOnboardUrl,
  digiLockerInitiateUrl,
  digiLockerFetchUrl,
  throughExistingUserUrl,
} from "../urls";

export const canOnboardAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(canOnboardUrl(), data, getTokenHeader(token))
      .then(({ data }) => next(data))
      .catch((err) =>
        next({
          error: true,
          message: err.response?.data?.message || err.message,
        }),
      );
  });
};

export const initiateDigiLocker = async (mobileNumber) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        digiLockerInitiateUrl(),
        {
          doc_type: "AADHAAR",
          mobile_number: mobileNumber,
          sign_up_preference: "PINLESS",
          check_account_linked: "false",
          consent: "Y",
          redirect_url: `${process.env.REACT_APP_BASE_URL}/onboard-buyer`,
        },
        getTokenHeader(token),
      )
      .then(({ data }) => next(data))
      .catch((err) =>
        next({
          error: true,
          message: err.response?.data?.message || err.message,
        }),
      );
  });
};

export const fetchDigiLockerData = async (sessionId) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .get(digiLockerFetchUrl(sessionId), getTokenHeader(token))
      .then(({ data }) => next(data))
      .catch((err) =>
        next({
          error: true,
          message: err.response?.data?.message || err.message,
        }),
      );
  });
};

export const onboardThroughExistingUser = async (payload) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(throughExistingUserUrl(), payload, getTokenHeader(token))
      .then(({ data }) => next(data))
      .catch((err) =>
        next({
          error: true,
          message: err.response?.data?.message || err.message,
        }),
      );
  });
};
